<template lang="html">
    <section class="categories">
        <AdminTools></AdminTools>
        <header>
            <div class="row">
                <div class="col-md-9"><h1 class="categories-title uppercase">Categories - sous categories</h1></div>
                <div class="categories-back txtRight col-md-3" style="padding-top: 25px;">
                    <router-link class="btn" to="/admin-tools">Retour à l'administration</router-link>
                </div>
            </div>
        </header>

        <aside class="categories-list">
            <b-tabs>
                <b-tab
                    v-for="section in currentSections"
                    :title="section.name"
                    :key="section.id"
                    v-on:click="generateListCurrentSection(section.id);"
                >
                    <div class="categories-new txtRight" style="padding-top: 10px;">
                        <b-btn
                            @click="openModalAddCategory(section.id, 'addCategory', null);"
                            class="btn pointer btn-addCategory"
                            v-b-modal="'defaultModal'"
                        >
                            Creer nouvelle categorie
                        </b-btn>
                    </div>
                    <div class="row" v-if="listCategories === null">
                        <div id="spinnerLoader" class="abs flexContainer">
                            <Spinner :animation-duration="2500" :size="70" :color="'#41b4e8'" class="loader"></Spinner>
                        </div>
                    </div>
                    <div v-else-if="listCategories.length === 0" class="row">Pas de categorie dans cette section</div>
                    <div v-else class="row">
                        <article v-for="(category, key) in listCategories" :key="key" class="cat col-md-6 col-xs-12">
                            <div class="cat-bloc row">
                                <div class="col-md-6">
                                    <h3 class="cat-title">{{ getTranslate(category.terms.name) }}</h3>
                                </div>
                                <div class="col-md-6 txtRight btn-action">
                                    <b-dropdown id="ddown1" text="Action">
                                        <b-dropdown-item @click="openModalAddCategory(section, 'addSubcat', category);" v-b-modal="'defaultModal'">
                                            + creer nouvelle sous categorie
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                            v-if="!category.subCategories.length"
                                            @click="openModalDeleteCategory(section, 'deleteCat', category);"
                                            v-b-modal="'defaultModal'"
                                        >
                                            + Supprimer categorie
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>
                            <div v-if="category.subCategories" class="subCat">
                                <div v-for="(subCategory, key) in category.subCategories" :key="key" class="subCat-block">
                                    <div class="row">
                                        <div class="subCat-title col-md-8 col-xs-12">{{ getTranslate(subCategory.terms.name) }}</div>
                                        <div class="subCat-update txtRight col-md-2 col-xs-12"></div>
                                        <div class="subCat-delete txtLeft col-md-2 col-xs-12">
                                            <span class="roundedIcon pointer" @click="openModalUpdateCategory(section.id, 'updateScat', subCategory);"
                                                ><i class="fas fa-pencil-alt"></i
                                            ></span>
                                            <span class="roundedIcon pointer" @click="openModalDeleteCategory(section, 'deleteSubCat', subCategory);"
                                                ><i class="fas fa-trash-alt"></i
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>
                </b-tab>
            </b-tabs>
        </aside>
        <Modal :action="dataAction"></Modal>
    </section>
</template>

<script>
import connectionBO from "../../../services/connectionBO";
import Spinner from "vue-simple-spinner";
import Modal from "./modal/Modal";
import { mapGetters, mapActions } from "vuex";
import httpService from "../../../components/service";
import AdminTools from "../../adminTools/Admin";
import cacheService from "@/services/cache";
import sectionService from "@/services/section";

export default {
    name: "Categories",
    props: [],
    mounted() {},
    components: {
        Spinner,
        Modal,
        AdminTools
    },
    data() {
        return {
            categories: [],
            sections: [],
            currentSections: [],
            showTab: false,
            dataAction: "",
            infosSubCat: [],
            listCategories: null
        };
    },
    async created() {
        this.currentSections = await sectionService.getAll();
    },
    methods: {
        ...mapActions({
            listCatBySection: "categories/listCatBySection"
        }),
        generateListCurrentSection(sectionId) {
            this.listCategories = null;
            this.listCatBySection(sectionId).then(() => {
                this.listCategories = this.getCategories;
            });
        },
        openModalUpdateCategory: function(section, action, category) {
            connectionBO.getThisSubCat(category.id).then(v => {
                this.dataAction = {
                    infoSubCat: v,
                    category: v,
                    action: action,
                    currentSections: section
                };
            });
            this.$root.$emit("bv::show::modal", "defaultModal");
        },
        openModalAddCategory: function(section, action, parentCategory) {
            this.dataAction = {
                action: action,
                category: parentCategory,
                currentBrand: cacheService.getCurrentBrandId(),
                currentSections: section
            };
            this.$root.$emit("bv::show::modal", "defaultModal");
        },
        openModalDeleteCategory: function(section, action, category) {
            httpService.get("/admin/categories/" + category.id + "/used").then(response => {
                this.dataAction = {
                    action: action,
                    category: category,
                    currentBrand: cacheService.getCurrentBrandId(),
                    currentSections: section,
                    showResponseUse: !!response.length
                };
                this.$root.$emit("bv::show::modal", "defaultModal");
            });
        }
    },
    computed: {
        ...mapGetters({
            getCategories: "categories/getCategories",
            getBrand: "brand/getBrand"
        })
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
.nav-item a {
    background: red !important;
    font-size: 24px !important;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    text-transform: uppercase;
}

#spinnerLoader {
    background: rgba(255, 255, 255, 0.7);
    left: 0;
    width: 100%;
    height: auto;
    .loader {
        position: relative;
        top: 50%;
        left: 50%;
    }
}

.categories {
    width: 100%;
    &-title {
        font-size: 24px;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        text-transform: uppercase;
        @extend %primary-text;
    }
    &-back {
    }
    &-new {
    }
    &-list {
        & .tab {
            &-pane {
                border: 1px solid #dee2e6;
                border-top: none;
                padding: 0 15px;
                @extend %primary-bloc;
                @extend %primary-text;
            }
        }
        & .cat {
            &-bloc {
                border-bottom: 2px solid #dee2e6;
                margin: 20px 0 10px 0;
                padding: 5px 0;
                background-color: #ccc;
                @extend %primary-text;
                @extend %second-border;
                & .btn-action {
                }
            }
            &-title {
                font-size: 20px;
                font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
                text-transform: uppercase;
                margin: 5px 0 0 0;
            }
            & .subCat {
                &-block {
                }
                &-title {
                    font-size: 18px;
                    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
                    margin: 10px 0;
                    font-weight: normal;
                    padding-left: 30px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Categories.vue?45d2e186